import {
  Box,
  Button,
  Container,
  Grid,
  Typography,
  styled,
} from "@mui/material";

import { useNavigate } from "react-router-dom";

function FailedPayment({ depositVerify }) {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm">
      <Grid container>
        <Grid item xs="12">
          <BoxStyle>
            <Grid container justifyContent="center" spacing={2}>
              <Grid item xs="12">
                <Typography color="error.main" variant="h3" dir="rtl">
                  پرداخت ناموفق
                </Typography>

                <Box mt={3}>
                  <Typography variant="h6" color="text.main">
                    {depositVerify?.errors[0]?.message}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs="6">
                <Button
                  color="success"
                  fullWidth
                  onClick={() => navigate("/deposit/4?isDigital=false&type=4")}
                >
                  بازگشت
                </Button>
              </Grid>
            </Grid>
          </BoxStyle>
        </Grid>
      </Grid>
    </Container>
  );
}

const BoxStyle = styled(Box)(({ theme }) => ({
  background: theme.palette.background.primaryGradient,
  padding: theme.spacing(2),
  textAlign: "center",
  borderRadius: "8px",
}));

export default FailedPayment;
